import React from "react";
import HighchartsReact from 'highcharts-react-official';
import Highstock from 'highcharts/highstock';
import { get_chart_options } from '../options';
import icon_info from "assets/images/icon-info.png";
import dayjs from 'dayjs';

const TrendSingleNightGraphs = (props) => {

    let TvData = props.tv_analytics.filter(d => {
        return d.kpi;
    })
    const data = (d) => {
        let result = get_chart_options({
            kpi_id: d.kpi,
            custom_chart_type: true,
            analytics: d,
        })
        // result.yAxis.min = 80
        result.yAxis.max = 100
        result.yAxis.tickAmount = 3

        result.yAxis.plotLines = [{
            color: '#FF0000',
            width: 2,
            value: 90,
            zIndex: 5
        }]
        return result
    }
    return (
        <ul className={"charts-wrap"} style={{ display: 'none' }} id="charts-TV">
            {

                TvData.map((d, i) =>
                (

                    <li key={'chart-div-block-' + d.kpi + i} className={"chart-block expanded"} id={`chart-${d.kpi}-TV`}>
                        <div className="chart-details expanded-chart-details">
                            <div className="chart-details-left">
                                <span id="date">{dayjs(d.recording_date).format("DD MMM YYYY")}</span>
                                <span className="graph-title">SPO2</span>
                                <span className="icon info-icon" data-tip data-for={`'tooltip-${"SPO2"}'`} ><img src={icon_info} alt="Icon" /></span>
                            </div>
                        </div>
                        {d.dataset &&
                            <HighchartsReact
                                kpi_name={d.kpi}
                                allowChartUpdate={true}
                                constructorType="stockChart"
                                containerProps={{ className: `chart-container-wrap`, id: "chart-kpi-SPO2" + i }}
                                key={d.kpi + i}
                                highcharts={Highstock}
                                options={data(d)}
                            />
                        }
                    </li>

                ))
            }
        </ul >
    )

};

export default TrendSingleNightGraphs;